<template>
  <span>
    <template v-if="enable_b_tooltip">
      <b-badge
        v-if="placement === 'top'"
        v-b-tooltip
        class="no-print no-row-click badge"
        :class="{ 'mb-1': mb }"
        :style="styling"
        :title="tooltip"
        variant="none"
        @click.stop.prevent="emitClick"
        @mouseleave="hovering = false"
        @mouseover="hovering = true"
      >
        <i
          v-if="warning_icon"
          class="far fa-exclamation-triangle text-warning mr-1"
          data-testid="last-icon"
          :style="stylingIcon"
        />
        <i
          v-if="icon"
          :class="fa_type + ' fa-' + icon"
          :data-testid="'icon-' + icon"
          :style="stylingIcon"
        />
        <slot />
      </b-badge>
      <b-badge
        v-if="placement === 'bottom'"
        v-b-tooltip
        v-b-tooltip.hover.bottom
        class="no-print no-row-click badge"
        :class="{ 'mb-1': mb }"
        :style="styling"
        :title="tooltip"
        variant="none"
        @click.stop.prevent="emitClick"
        @mouseleave="hovering = false"
        @mouseover="hovering = true"
      >
        <i
          v-if="icon"
          class="far"
          :class="'fa-' + icon"
          :data-testid="'icon-' + icon"
          :style="stylingIcon"
        />
        <slot />
      </b-badge>
      <b-badge
        v-if="placement === 'left'"
        v-b-tooltip
        v-b-tooltip.hover.left
        class="no-print no-row-click badge"
        :class="{ 'mb-1': mb }"
        :style="styling"
        :title="tooltip"
        variant="none"
        @click.stop.prevent="emitClick"
        @mouseleave="hovering = false"
        @mouseover="hovering = true"
      >
        <i
          v-if="icon"
          class="far"
          :class="'fa-' + icon"
          :data-testid="'icon-' + icon"
          :style="stylingIcon"
        />
        <slot />
      </b-badge>
      <b-badge
        v-if="placement === 'right'"
        v-b-tooltip
        v-b-tooltip.hover.right
        class="no-print no-row-click badge"
        :class="{ 'mb-1': mb }"
        :style="styling"
        :title="tooltip"
        variant="none"
        @click.stop.prevent="emitClick"
        @mouseleave="hovering = false"
        @mouseover="hovering = true"
      >
        <i
          v-if="icon"
          class="far"
          :class="'fa-' + icon"
          :data-testid="'icon-' + icon"
          :style="stylingIcon"
        />
        <slot />
      </b-badge>
    </template>
    <template v-else>
      <b-badge
        class="no-print no-row-click badge"
        :class="{ 'mb-1': mb }"
        :style="styling"
        :title="tooltip"
        variant="none"
        @click.stop.prevent="emitClick"
        @mouseleave="hovering = false"
        @mouseover="hovering = true"
      >
        <i
          v-if="icon"
          class="far"
          :class="'fa-' + icon"
          :data-testid="'icon-' + icon"
          :style="stylingIcon"
        />
        <slot />
      </b-badge>
    </template>
  </span>
</template>

<script>
export default {
  name: 'IconAction',
  props: {
    enable_b_tooltip: {
      type: Boolean,
      default: true,
    },
    is_table_action: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top',
    },
    is_dnd: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    warning_icon: {
      type: Boolean,
      default: false,
    },
    mb: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: String,
    fa_type: {
      type: String,
      default: 'far',
    },
    width: Number,
    tooltip: String,
    icon_size: String,
    padding: String,
    height: Number,
    has_border: { type: Boolean, default: true },
  },
  data() {
    return {
      hovering: false,
      textDecoration: 'underline',
      textWeight: 'bold',
      color_: '',
      color_dict: {
        danger: '#dc3545',
        danger_low: '#B71F41',
        primary: '#0A4650',
        primary_low: '#2C526663',
        secondary: '#35ABB0',
        secondary_low: '#35ABB066',
        warning: '#ffc107',
        warning_low: '#ffc10766',
        success: '#28a745',
        success_low: '#28a74566',
        disabled: '#aaaaaa',
        disabled_low: '#aaaaaa66',
        gray: '#656565',
        gray_low: '#65656500',
        light: 'white',
      },
    }
  },
  computed: {
    styling: function () {
      return {
        color: !this.hovering
          ? this.color_dict[this.color_]
          : this.is_table_action
          ? this.color_dict[this.color_]
          : 'white',
        backgroundColor: this.hovering
          ? this.is_table_action
            ? this.color_dict[this.color_ + '_low']
            : this.color_dict[this.color_]
          : '',
        padding: this.padding,
        width: this.width ? this.width + 'px' : null,
        'font-weight': 400,
        cursor: !this.disabled ? 'pointer' : 'default',
        'border-width': this.is_dnd ? '0px' : '0.5px',
        'border-style': 'solid',
        'border-color': !this.hovering ? this.color_dict[this.color_ + '_low'] : this.color_dict[this.color_],
        height: this.height ? this.height + 'px' : null,
        'align-items': this.height ? 'center' : null,
        display: this.height ? 'flex' : null,
        border: this.has_border ? '1px solid' : 'none',
      }
    },
    stylingIcon: function () {
      return {
        'font-size': this.icon_size,
      }
    },
  },
  watch: {
    disabled: function (v) {
      if (v) {
        this.color_ = 'disabled'
      } else {
        this.color_ = this.color
      }
    },
    color: function (v) {
      this.color_ = v
    },
  },
  mounted() {
    this.color_ = this.color
    if (this.disabled) {
      this.color_ = 'disabled'
    }
  },
  methods: {
    emitClick(ev) {
      if (!this.disabled) {
        this.$emit('click', ev)
      }
    },
  },
}
</script>
